import React from "react";
import cx from "classnames";
import { Image } from "src/components/image";

import styles from "./featured-in.module.css";

interface FeaturedInProps {
  module: {
    publicationLogos: [
      {
        asset: {
          _id: string;
        };
      }
    ];
  };
}
export const FeaturedIn = ({ module }: FeaturedInProps) => {
  const { publicationLogos } = module;
  return (
    <div className={cx(styles.featuredIn)}>
      <h2 className={cx("small-caps-13", styles.heading)}>Featured In</h2>
      <div className={styles.logos}>
        {publicationLogos &&
          publicationLogos.map((logo, index) => (
            <div className={styles.logo} key={index}>
              <Image
                className={styles.logoImage}
                imageId={logo.asset._id}
                width={216}
                style={{ height: "100%" }}
                objectFit="contain"
              />
            </div>
          ))}
      </div>
    </div>
  );
};
